import { createRoute, redirect } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { Route as pathlessAuthenticatedRoute } from '../../route';

// The override browser moved to Demand forecasting → Overrides. Bookmarks and
// pasted links outlive a move, so the old path still resolves.
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/procurement/override-reviews',
  staticData: {
    app: {
      access: {
        modulesAnyOf: [ProductModule.PROCUREMENT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Inventory }],
      },
    },
  },
  beforeLoad: () => {
    throw redirect({ to: '/procurement/demand-forecasting/overrides' });
  },
});
